import React from 'react';
import './Scoreboard.scss';

import steelRank from'../../../styles/svg_icons/steel_rank.svg';
import concreteRank from'../../../styles/svg_icons/concrete_rank.svg';
import woodRank from'../../../styles/svg_icons/wood_rank.svg';
import scoreRank from'../../../styles/svg_icons/score_rank.svg';
import goldRing from "../../../styles/svg_icons/achievments/gold_ring.svg";
import silverRing from "../../../styles/svg_icons/achievments/silver_ring.svg";
import defaultRing from "../../../styles/svg_icons/achievments/default_ring.svg";
import goldConcrete from "../../../styles/svg_icons/achievments/gold_concrete.svg";
import goldSteel from "../../../styles/svg_icons/achievments/gold_steel.svg";
import goldGeo from "../../../styles/svg_icons/achievments/gold_geo.svg";
import silverConcrete from "../../../styles/svg_icons/achievments/silver_concrete.svg";
import silverSteel from "../../../styles/svg_icons/achievments/silver_steel.svg";
import silverGeo from "../../../styles/svg_icons/achievments/silver_geo.svg";
import silverWood from "../../../styles/svg_icons/achievments/silver_wood.svg";
import goldWood from "../../../styles/svg_icons/achievments/gold_wood.svg";


const Scoreboard = (props) => {
    //const {dispatch} = props;
        return (
            <div className="Scoreboard">
                <div className='status-block'>
                    <div className="score-container-row-ring">
                        <img src={defaultRing} className="status-img" alt="statusRing" />
                        {/*p className="status-text">0</p>*/}
                        
                    </div>
                    <div className="score-container-row">
                        <img src={silverConcrete} className="status-img" alt="statusConcrete" />
                        <p className="status-text">0</p>
                        
                    </div>
                    <div className="score-container-row">
                        <img src={silverSteel} className="status-img" alt="statusSteel" />
                        <p className="status-text">0</p>
                        
                    </div> 
                  
                    <div className="score-container-row">
                        <img src={silverGeo} className="status-img" alt="statusGeo" />
                        <p className="status-text">0</p>
                        
                    </div>
                    <div className="score-container-row">
                        <img src={silverWood} className="status-img" alt="statusWood" />
                        <p className="status-text">0</p>
                        
                    </div>    
                </div>          
                <div className="score-container">
                    <img src={steelRank} className="score-img" alt="steelrank" />
                    <p className="score-text">{props.authData.s_score}</p>
                    <p className="score-text-all">{props.authData.s_total}</p>
                </div>
                <div className="score-container">
                    <img src={concreteRank} className="score-img" alt="concreterank" />
                    <p className="score-text">{props.authData.c_score}</p>
                    <p className="score-text-all">{props.authData.c_total}</p>
                </div>
                <div className="score-container">
                    <img src={woodRank} className="score-img" alt="woodrank" />
                    <p className="score-text">{props.authData.w_score}</p>
                    <p className="score-text-all">{props.authData.w_total}</p>
                </div>
                <div className="score-container">
                    <img src={scoreRank} className="score-img" alt="scorerank" />
                    <p className="score-text">{
                    props.authData.sumQuizes
                }
                    </p>
                    <p className="score-text-all">{props.authData.quizes_total}</p>
                </div>
                
                
            </div>
        )
    
}
export default Scoreboard;